import { createContext } from "react";

const DF_OT0056Context = createContext();

export { DF_OT0056Context };
